import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import {
  Home2,
  Chart,
  TrendUp,
  Star1,
  ArrangeVerticalCircle,
  Calendar,
  Building,
  Profile2User,
  ClipboardText,
  Briefcase,
  Location,
  People,
  Task,
  TaskSquare,
  TicketDiscount,
  Graph,
  DocumentText,
  Setting2,
  FolderOpen,
  ChartSquare,
  Call,
  MoneyRecive,
  Receipt,
  UserTag,
  SecurityUser,
  TicketStar,
  Setting4,
} from "iconsax-reactjs";
import { useTheme } from "../../contexts/ThemeContext";

const allPages = [
  {
    to: "/dashboard",
    icon: Home2,
    label: "Dashboard",
    section: "Home",
    color: "#6366F1",
  },
  {
    to: "/leads",
    icon: TrendUp,
    label: "Leads",
    section: "Sales",
    color: "#8B5CF6",
  },
  {
    to: "/my-leads",
    icon: Star1,
    label: "My Leads",
    section: "Sales",
    color: "#8B5CF6",
  },
  {
    to: "/cleansed-leads",
    icon: ArrangeVerticalCircle,
    label: "Cleansed Leads",
    section: "Sales",
    color: "#8B5CF6",
  },
  {
    to: "/opportunities",
    icon: Chart,
    label: "Opportunities",
    section: "Sales",
    color: "#8B5CF6",
  },
  {
    to: "/my-opportunities",
    icon: Star1,
    label: "My Opportunities",
    section: "Sales",
    color: "#8B5CF6",
  },
  {
    to: "/appointments",
    icon: Calendar,
    label: "Appointments",
    section: "Sales",
    color: "#8B5CF6",
  },
  {
    to: "/accounts",
    icon: Building,
    label: "Accounts",
    section: "Sales",
    color: "#8B5CF6",
  },
  {
    to: "/contacts",
    icon: Profile2User,
    label: "Contacts",
    section: "Sales",
    color: "#8B5CF6",
  },
  {
    to: "/engagements",
    icon: TrendUp,
    label: "Cadence",
    section: "Sales",
    color: "#8B5CF6",
  },
  {
    to: "/cases",
    icon: ClipboardText,
    label: "Cases",
    section: "Sales",
    color: "#8B5CF6",
  },
  {
    to: "/projects",
    icon: Briefcase,
    label: "Projects",
    section: "Sales",
    color: "#8B5CF6",
  },
  {
    to: "/visits",
    icon: Location,
    label: "Visits",
    section: "Sales",
    color: "#8B5CF6",
  },
  {
    to: "/tasks",
    icon: Task,
    label: "Tasks",
    section: "Work",
    color: "#10B981",
  },
  {
    to: "/team-tasks",
    icon: TaskSquare,
    label: "Team Tasks",
    section: "Work",
    color: "#10B981",
  },
  //   {
  //     to: "/tickets",
  //     icon: TicketDiscount,
  //     label: "Tickets",
  //     section: "Work",
  //     color: "#10B981",
  //   },
  //   { to: "/team-calendar", icon: Calendar, label: "Team Calendar", section: "Work", color: "#10B981" },
  {
    to: "/files",
    icon: FolderOpen,
    label: "Files",
    section: "Work",
    color: "#10B981",
  },
  {
    to: "/users",
    icon: People,
    label: "Team",
    section: "People",
    color: "#F59E0B",
  },
  //   {
  //     to: "/customers",
  //     icon: Profile2User,
  //     label: "Customers",
  //     section: "People",
  //     color: "#F59E0B",
  //   },
  //   { to: "/transcripts", icon: DocumentText, label: "Transcripts", section: "Data", color: "#3B82F6" },
  //   { to: "/analytics", icon: Graph, label: "Analytics", section: "Data", color: "#3B82F6" },
  //   { to: "/reports", icon: ChartSquare, label: "Reports", section: "Data", color: "#3B82F6" },
  {
    to: "/quotes",
    icon: Receipt,
    label: "Quotes",
    section: "Finance",
    color: "#EC4899",
  },
  {
    to: "/products",
    icon: MoneyRecive,
    label: "Products",
    section: "Finance",
    color: "#EC4899",
  },
  {
    to: "/credits",
    icon: MoneyRecive,
    label: "Credits",
    section: "Finance",
    color: "#EC4899",
  },
  {
    to: "/installs",
    icon: Setting4,
    label: "Installs",
    section: "Operations",
    color: "#14B8A6",
  },
  {
    to: "/visit-notifications",
    icon: Location,
    label: "Visit Notifications",
    section: "Operations",
    color: "#14B8A6",
  },
  //   {
  //     to: "/lead-call-data",
  //     icon: Call,
  //     label: "Lead Call Data",
  //     section: "Operations",
  //     color: "#14B8A6",
  //   },
  {
    to: "/broadband-search",
    icon: Graph,
    label: "Broadband Search",
    section: "Operations",
    color: "#14B8A6",
  },
  //   {
  //     to: "/settings",
  //     icon: Setting2,
  //     label: "Settings",
  //     section: "Settings",
  //     color: "#6B7280",
  //   },
  {
    to: "/user-settings",
    icon: UserTag,
    label: "Settings",
    section: "Settings",
    color: "#6B7280",
  },
  {
    to: "/settings/integrations",
    icon: Setting4,
    label: "Integrations",
    section: "Settings",
    color: "#6B7280",
  },
  {
    to: "/settings/emails",
    icon: SecurityUser,
    label: "Email Connection",
    section: "Settings",
    color: "#6B7280",
  },
  {
    to: "/dashboards",
    icon: ChartSquare,
    label: "TV Dashboards",
    section: "Settings",
    color: "#6B7280",
  },
  {
    to: "/my-targets",
    icon: TicketStar,
    label: "My Targets",
    section: "Home",
    color: "#6366F1",
  },
  {
    to: "/my-performance",
    icon: TrendUp,
    label: "My Performance",
    section: "Home",
    color: "#6366F1",
  },
];

const sections = [
  "Home",
  "Sales",
  "Work",
  "People",
  "Data",
  "Finance",
  "Operations",
  "Settings",
];

const sectionColors = {
  Home: "#6366F1",
  Sales: "#8B5CF6",
  Work: "#10B981",
  People: "#F59E0B",
  Data: "#3B82F6",
  Finance: "#EC4899",
  Operations: "#14B8A6",
  Settings: "#6B7280",
};

const AllPages = () => {
  const navigate = useNavigate();
  const { isDarkMode } = useTheme();
  const [search, setSearch] = useState("");
  const [activeSection, setActiveSection] = useState("All");

  const filtered = allPages.filter((p) => {
    const matchesSearch = p.label.toLowerCase().includes(search.toLowerCase());
    const matchesSection =
      activeSection === "All" || p.section === activeSection;
    return matchesSearch && matchesSection;
  });

  const grouped = sections.reduce((acc, sec) => {
    const items = filtered.filter((p) => p.section === sec);
    if (items.length > 0) acc[sec] = items;
    return acc;
  }, {});

  const bg = isDarkMode ? "#0C0E12" : "#F9FAFB";
  const cardBg = isDarkMode ? "#13161B" : "#FFFFFF";
  const cardBorder = isDarkMode ? "#22262F" : "#E5E7EB";
  const cardHover = isDarkMode ? "#1A1D23" : "#F3F4F6";
  const textPrimary = isDarkMode ? "#F7F7F7" : "#111827";
  const textMuted = isDarkMode ? "#61656C" : "#9CA3AF";
  const textSub = isDarkMode ? "#94979C" : "#6B7280";
  const inputBg = isDarkMode ? "#13161B" : "#FFFFFF";
  const inputBorder = isDarkMode ? "#22262F" : "#D1D5DB";
  const pillActive = isDarkMode ? "#22262F" : "#EEF2FF";
  const pillText = isDarkMode ? "#CECFD2" : "#374151";

  return (
    <div
      style={{
        background: bg,
        minHeight: "100vh",
        padding: "32px 40px",
        fontFamily: "inherit",
      }}
    >
      {/* Header */}
      <div style={{ marginBottom: 28 }}>
        <h1
          style={{
            fontSize: 24,
            fontWeight: 700,
            color: textPrimary,
            margin: 0,
          }}
        >
          All Pages
        </h1>
        <p style={{ fontSize: 14, color: textMuted, marginTop: 6 }}>
          {allPages.length} pages across {sections.length} sections
        </p>
      </div>

      {/* Search + Filter Bar */}
      <div
        style={{
          display: "flex",
          gap: 12,
          marginBottom: 32,
          flexWrap: "wrap",
          alignItems: "center",
        }}
      >
        <input
          type="text"
          placeholder="Search pages..."
          value={search}
          onChange={(e) => setSearch(e.target.value)}
          style={{
            background: inputBg,
            border: `1px solid ${inputBorder}`,
            borderRadius: 8,
            padding: "8px 14px",
            fontSize: 14,
            color: textPrimary,
            outline: "none",
            width: 220,
          }}
        />
        <div style={{ display: "flex", gap: 6, flexWrap: "wrap" }}>
          {["All", ...sections].map((sec) => (
            <button
              key={sec}
              onClick={() => setActiveSection(sec)}
              style={{
                padding: "5px 14px",
                borderRadius: 20,
                fontSize: 12,
                fontWeight: 500,
                border: `1px solid ${activeSection === sec ? sectionColors[sec] || "#6366F1" : cardBorder}`,
                background:
                  activeSection === sec
                    ? (sectionColors[sec] || "#6366F1") + "20"
                    : "transparent",
                color:
                  activeSection === sec
                    ? sectionColors[sec] || "#6366F1"
                    : pillText,
                cursor: "pointer",
                transition: "all 0.15s",
              }}
            >
              {sec}
            </button>
          ))}
        </div>
      </div>

      {/* Sections */}
      {Object.keys(grouped).length === 0 ? (
        <div
          style={{
            textAlign: "center",
            color: textMuted,
            marginTop: 80,
            fontSize: 15,
          }}
        >
          No pages match your search.
        </div>
      ) : (
        Object.entries(grouped).map(([section, items]) => (
          <div key={section} style={{ marginBottom: 40 }}>
            {/* Section heading */}
            <div
              style={{
                display: "flex",
                alignItems: "center",
                gap: 10,
                marginBottom: 16,
              }}
            >
              <div
                style={{
                  width: 10,
                  height: 10,
                  borderRadius: "50%",
                  background: sectionColors[section],
                  flexShrink: 0,
                }}
              />
              <h2
                style={{
                  fontSize: 12,
                  fontWeight: 600,
                  color: textSub,
                  textTransform: "uppercase",
                  letterSpacing: "0.08em",
                  margin: 0,
                }}
              >
                {section}
              </h2>
              <div style={{ flex: 1, height: 1, background: cardBorder }} />
            </div>

            {/* Cards grid */}
            <div
              style={{
                display: "grid",
                gridTemplateColumns: "repeat(auto-fill, minmax(160px, 1fr))",
                gap: 12,
              }}
            >
              {items.map((page) => (
                <PageCard
                  key={page.to}
                  page={page}
                  onClick={() => navigate(page.to)}
                  cardBg={cardBg}
                  cardBorder={cardBorder}
                  cardHover={cardHover}
                  textPrimary={textPrimary}
                  textMuted={textMuted}
                />
              ))}
            </div>
          </div>
        ))
      )}
    </div>
  );
};

const PageCard = ({
  page,
  onClick,
  cardBg,
  cardBorder,
  cardHover,
  textPrimary,
  textMuted,
}) => {
  const [hovered, setHovered] = React.useState(false);
  const Icon = page.icon;

  return (
    <button
      onClick={onClick}
      onMouseEnter={() => setHovered(true)}
      onMouseLeave={() => setHovered(false)}
      style={{
        background: hovered ? cardHover : cardBg,
        border: `1px solid ${hovered ? page.color + "60" : cardBorder}`,
        borderRadius: 12,
        padding: "18px 16px",
        cursor: "pointer",
        display: "flex",
        flexDirection: "column",
        alignItems: "flex-start",
        gap: 12,
        textAlign: "left",
        transition: "all 0.18s ease",
        transform: hovered ? "translateY(-2px)" : "translateY(0)",
        boxShadow: hovered ? `0 4px 16px ${page.color}20` : "none",
      }}
    >
      <div
        style={{
          width: 36,
          height: 36,
          borderRadius: 8,
          background: page.color + "18",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          flexShrink: 0,
          transition: "background 0.18s",
        }}
      >
        <Icon style={{ width: 18, height: 18, color: page.color }} />
      </div>
      <span
        style={{
          fontSize: 13,
          fontWeight: 500,
          color: textPrimary,
          lineHeight: 1.3,
          wordBreak: "break-word",
        }}
      >
        {page.label}
      </span>
    </button>
  );
};

export default AllPages;
